(function(){
  // KAI: pasica s kodo v kosarici. Deluje v obeh predalih - tematskem (#cart-drawer)
  // in landerjevem (#kai-cart-drawer). Koda se razkrije z enim klikom in se ob
  // razkritju uveljavi prek /discount/<koda>, tako da jo blagajna ze ima.
  var CODE = 'WELCOME';
  // 23. 10. 2026 (Gasper): besedila prek window.KAI_T (lander), drugje angleska rezerva.
  var _T=window.KAI_T||{};
  // SL/HR rezerva (23. 10. 2026)
  var _D=({ sl:{ code_h:'Čaka vas koda za popust', code_s:'Kliknite za prikaz kode – popust se upošteva ob zaključku nakupa.', code_reveal:'Prikaži kodo', code_copy:'Kopiraj', code_copied:'Kopirano' }, hr:{ code_h:'Čeka vas kod za popust', code_s:'Kliknite za prikaz koda – popust se obračunava pri završetku kupnje.', code_reveal:'Prikaži kod', code_copy:'Kopiraj', code_copied:'Kopirano' } })[(window.Shopify&&Shopify.locale)||'']||{};
  function t(k,d){ var v=_T[k]; if(typeof v!=='string'||!v||v.indexOf('Translation missing')===0) return (_D[k]||d); return v; }
  function tf(k,d,vars){ var s=t(k,d); for(var vk in vars){ s=s.split('{'+vk+'}').join(vars[vk]); } return s; }
  var KEY  = 'kaiCodeRevealed';
  var ID   = 'kai-code';
  var STY  = 'kai-code-style';

  function revealed(){ try{ return sessionStorage.getItem(KEY) === '1'; }catch(e){ return false; } }
  function markRevealed(){ try{ sessionStorage.setItem(KEY,'1'); }catch(e){} }

  function injectStyle(){
    if(document.getElementById(STY)) return;
    var s = document.createElement('style'); s.id = STY;
    s.textContent =
      '#kai-code{margin:12px 20px 2px;border:1.5px dashed #AEBCC8;border-radius:12px;padding:12px 14px;font-family:inherit}'+
      '#kai-code .kc-h{margin:0 0 3px;font-size:13px;font-weight:800;line-height:1.3;color:rgb(var(--text-color,8 9 18))}'+
      '#kai-code .kc-s{margin:0;font-size:11.5px;line-height:1.4;color:rgb(var(--text-color,70 80 90) / .74)}'+
      '#kai-code .kc-r{display:flex;align-items:center;gap:8px;margin-top:9px}'+
      '#kai-code .kc-v{flex:1;border:1.5px dashed #AEBCC8;border-radius:8px;background:#fff;padding:8px 10px;'+
        'font-size:14px;font-weight:800;letter-spacing:.09em;text-align:center;color:rgb(var(--text-color,8 9 18));'+
        'transition:filter .25s ease;user-select:all}'+
      '#kai-code .kc-v.hid{filter:blur(5px);user-select:none}'+
      '#kai-code .kc-b{flex-shrink:0;border:0;border-radius:8px;padding:9px 14px;font:inherit;font-size:12px;'+
        'font-weight:700;cursor:pointer;background:rgb(var(--button-background-primary,8 9 18));'+
        'color:rgb(var(--button-text-primary,255 255 255))}'+
      '#kai-code .kc-b:disabled{opacity:.6;cursor:default}';
    (document.head || document.documentElement).appendChild(s);
  }

  // BF 2026 (Ana, 25. 10. 2026): ce so v kosarici Black Friday paketi (_bf), kode ne ponujamo in je ne uveljavimo (popusti se ne sestevajo).
  var _bf=false, _bfAt=0, _bfP=null, _cleared=false;
  function chkBf(force){
    if(!force && _bfP) return _bfP;
    if(!force && Date.now()-_bfAt<3000) return Promise.resolve(_bf);
    _bfAt=Date.now();
    _bfP=fetch('/cart.js',{credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(r){ return r.json(); }).then(function(c){ _bf=((c&&c.items)||[]).some(function(it){ return !!(it&&it.properties&&it.properties._bf); }); _bfP=null; return _bf; }).catch(function(){ _bfP=null; return _bf; });
    return _bfP;
  }
  function bfMode(){
    var e=document.getElementById(ID); if(e&&e.parentNode) e.parentNode.removeChild(e);
    try{ var links=document.querySelectorAll('a[href*="discount="]'); for(var i=0;i<links.length;i++){ links[i].setAttribute('href', links[i].getAttribute('href').replace(/([?&])discount=[^&]*(&?)/,function(m,a,b){ return b?a:''; }).replace(/[?&]$/,'')); } }catch(e){}
    if(revealed() && !_cleared){ _cleared=true; try{ fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({discount:''})}).catch(function(){}); }catch(e){} }
  }

  function applyDiscount(){
    if(_bf) return;
    try{
      fetch('/discount/' + encodeURIComponent(CODE), { credentials:'same-origin' }).catch(function(){});
    }catch(e){}
    // rezerva: ce kdo klikne checkout, preden je piskotek zapisan
    try{
      var links = document.querySelectorAll('a[href="/checkout"],a[href$="/checkout"],a.kai-cart-checkout');
      for(var i=0;i<links.length;i++){
        var h = links[i].getAttribute('href') || '/checkout';
        if(h.indexOf('discount=') < 0){
          links[i].setAttribute('href', h + (h.indexOf('?')<0?'?':'&') + 'discount=' + encodeURIComponent(CODE));
        }
      }
    }catch(e){}
  }

  function build(){
    var box = document.createElement('div');
    box.id = ID;
    box.innerHTML =
      '<p class="kc-h">'+t('code_h','You have a discount code waiting')+'</p>'+
      '<p class="kc-s">'+t('code_s','Tap to reveal - it applies at checkout.')+'</p>'+
      '<div class="kc-r"><span class="kc-v hid">'+CODE+'</span>'+
      '<button type="button" class="kc-b">'+t('code_reveal','Reveal')+'</button></div>';
    var val = box.querySelector('.kc-v');
    var btn = box.querySelector('.kc-b');
    function open(){
      val.classList.remove('hid');
      btn.textContent = t('code_copy','Copy');
      markRevealed();
      applyDiscount();
    }
    if(revealed()) open();
    btn.addEventListener('click', function(){
      if(val.classList.contains('hid')){ open(); return; }
      try{
        navigator.clipboard.writeText(CODE).then(function(){
          btn.textContent = t('code_copied','Copied');
          setTimeout(function(){ btn.textContent = t('code_copy','Copy'); }, 1600);
        }).catch(function(){});
      }catch(e){}
    });
    return box;
  }

  function hasItems(){
    var n = document.getElementById('kai-cart-badge') || document.getElementById('kai-cart-count');
    if(n && parseInt(n.textContent, 10) > 0) return true;
    if(document.querySelector('#kai-cart-body .kai-ci')) return true;
    if(document.querySelector('#cart-drawer .line-item, #cart-drawer [class*="line-item"]')) return true;
    return false;
  }

  function place(){
    if(document.getElementById(ID)) return;
    if(!hasItems()) return;
    injectStyle();
    // landerjev predal
    var lb = document.getElementById('kai-cart-body');
    if(lb && lb.parentNode){ lb.parentNode.insertBefore(build(), lb); return; }
    // tematski predal - nad pas z darili, ce ta obstaja
    var d = document.getElementById('cart-drawer');
    if(!d) return;
    var host = d.querySelector('.v-stack.gap-5') || d.querySelector('.v-stack') || d;
    var gb = document.getElementById('kai-gb');
    if(gb && gb.parentNode === host){ host.insertBefore(build(), gb); }
    else { host.insertBefore(build(), host.firstChild); }
  }

  function drop(){
    var e = document.getElementById(ID);
    if(e && !hasItems() && e.parentNode) e.parentNode.removeChild(e);
  }

  var _tm = null;
  function schedule(force){ clearTimeout(_tm); _tm = setTimeout(function(){ chkBf(force===true).then(function(isBf){ if(isBf){ bfMode(); return; } drop(); place(); }); }, 140); }

  function boot(){
    schedule();
    try{
      new MutationObserver(function(muts){
        for(var i=0;i<muts.length;i++){
          var tg = muts[i].target;
          if(tg && tg.id === ID) return;
          if(tg && tg.closest && tg.closest('#' + ID)) return;
        }
        schedule();
      }).observe(document.body, { childList:true, subtree:true });
    }catch(e){}
    ['cart:refresh','cart:change','cart:updated'].forEach(function(n){
      document.addEventListener(n, function(){ schedule(true); });
    });
  }

  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
